import gql from 'graphql-tag';

export const ChatContactFragment = gql`
  fragment ChatContact on ChatContact {
    _id
    firstName
    lastName
    email
    role
    isExternal
  }
`;

export const ChatPatientFragment = gql`
  fragment ChatPatient on ChatPatient {
    _id
    firstName
    lastName
    dob
    mrn
    email
    isExternal
  }
`;

export const ChatMessageFragment = gql`
  fragment ChatMessage on ChatMessageRes {
    _id
    conversationId
    senderId
    text
    isDeleted
    createdAt
    hasPatient
    patient {
      ...ChatPatient
    }
  }
  ${ChatPatientFragment}
`;

export const GET_CHAT_CONTACTS = gql`
  query GetChatContacts($params: ChatContactsInput) {
    chatContacts(params: $params) {
      ...ChatContact
    }
  }
  ${ChatContactFragment}
`;

export const GET_MY_CHAT_CONVERSATIONS = gql`
  query GetMyChatConversations {
    myChatConversations {
      _id
      lastMessageAt
      unreadCount
      otherUser {
        ...ChatContact
      }
      lastMessage {
        ...ChatMessage
      }
    }
  }
  ${ChatContactFragment}
  ${ChatMessageFragment}
`;

export const GET_CHAT_UNREAD_CONVERSATIONS = gql`
  query GetChatUnreadConversations {
    chatUnreadConversations
  }
`;

export const GET_CHAT_MESSAGES = gql`
  query GetChatMessages($params: ChatMessagesInput!) {
    chatMessages(params: $params) {
      hasMore
      nodes {
        ...ChatMessage
      }
    }
  }
  ${ChatMessageFragment}
`;

export const GET_CHAT_PATIENT_SEARCH = gql`
  query GetChatPatientSearch($params: ChatPatientSearchInput!) {
    chatPatientSearch(params: $params) {
      ...ChatPatient
    }
  }
  ${ChatPatientFragment}
`;

export const SEND_CHAT_MESSAGE = gql`
  mutation SendChatMessage($params: SendChatMessageInput!) {
    sendChatMessage(params: $params) {
      ...ChatMessage
    }
  }
  ${ChatMessageFragment}
`;

export const DELETE_CHAT_MESSAGE = gql`
  mutation DeleteChatMessage($params: ChatMessageIdInput!) {
    deleteChatMessage(params: $params) {
      ...ChatMessage
    }
  }
  ${ChatMessageFragment}
`;

export const MARK_CHAT_CONVERSATION_READ = gql`
  mutation MarkChatConversationRead($params: ChatConversationInput!) {
    markChatConversationRead(params: $params)
  }
`;

export const SUBSCRIPTION_CHAT_EVENTS = gql`
  subscription SubscriptionChatEvents {
    chatEvents {
      type
      conversationId
      message {
        ...ChatMessage
      }
    }
  }
  ${ChatMessageFragment}
`;
